var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "medicationInformation",
      "centered": "",
      "size": "lg",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "modal-title"
        }, [_vm._v("Medication Information")]), _c('button', {
          staticClass: "close",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.$emit('onCloseModal') && (_vm.logData = []);
            }
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "employerTable-card p-0 mt-0 mb-3 table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN")]), _c('th', [_vm._v("Type")]), _c('th', [_vm._v("Name")]), _c('th', [_vm._v("Medication")]), _c('th', [_vm._v("Dosage")]), _c('th', [_vm._v("Medical Condition")]), _c('th', [_vm._v("Additional Notes")])])]), _vm.logData.length == 0 ? _c('tbody', [_c('tr', {
    staticClass: "text-center"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Records Found")])])]) : _vm._e(), _vm._l(_vm.logData, function (logs, index) {
    return _c('tbody', {
      key: logs.id
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _c('td', [_vm._v(" " + _vm._s(logs.dep_relation == "C" ? "Child" : logs.dep_relation == "S" ? "Spouse" : "Primary") + " ")]), _c('td', [_vm._v(" " + _vm._s(logs.dep_relation ? logs.dep_fname + (logs.dep_mname ? " " + logs.dep_mname : "") + " " + logs.dep_lname : logs.user_fname + (logs.user_mname ? " " + logs.user_mname : "") + " " + logs.user_lname) + " ")]), _c('td', [_vm._v(" " + _vm._s(logs.medication || "") + " ")]), _c('td', [_vm._v(_vm._s(logs.dosage || ""))]), _c('td', [_vm._v(_vm._s(logs.medical_condition || ""))]), _c('td', [_vm._v(_vm._s(logs.additional_notes || ""))])])]);
  })], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }